import React from 'react';
import { Alert, Box, Chip, Stack, Typography } from '@mui/joy';
import type { OrderEvent } from '../../lib/distributorsApi';

const SOURCE_COLORS: Record<string, 'primary' | 'neutral' | 'success' | 'warning'> = {
  webhook: 'success',
  poll: 'primary',
  system: 'neutral',
  user: 'warning',
};

/** Newest-first status timeline for an API-submitted order. */
export default function OrderStatusTimeline({ events }: { events: OrderEvent[] }) {
  if (!events || events.length === 0) {
    return (
      <Alert color="neutral" variant="soft">
        No status events yet — the distributor updates appear here once the
        branch starts processing the order.
      </Alert>
    );
  }

  return (
    <Stack spacing={1}>
      {events.map((event) => (
        <Box
          key={event.id}
          sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
        >
          <Typography level="body-xs" color="neutral" sx={{ minWidth: 150 }}>
            {new Date(event.occurred_at).toLocaleString()}
          </Typography>
          <Chip size="sm" variant="soft" color={SOURCE_COLORS[event.source] || 'neutral'}>
            {event.source}
          </Chip>
          <Typography level="body-sm">
            {event.event_type === 'status_change' && event.old_status && event.new_status
              ? `${event.old_status} → ${event.new_status}`
              : event.event_type.replace(/_/g, ' ')}
          </Typography>
          {event.external_status && (
            <Chip size="sm" variant="outlined" color="neutral">
              {event.external_status}
            </Chip>
          )}
        </Box>
      ))}
    </Stack>
  );
}
